export function vNodeIsComponent(vnode) {
  var componentOptions = vnode.componentOptions;

  if (!componentOptions) {
    return false;
  }

  return true;
}
export function noop() {}

function isPointsEq(a1, a2) {
  return a1[0] === a2[0] && a1[1] === a2[1];
}

export function getClassNameFromAlign(builtinPlacements, prefixCls, align) {
  var points = align.points;
  var placements = Object.keys(builtinPlacements).filter(function (v) {
    return isPointsEq(builtinPlacements[v].points, points);
  });

  if (placements.length > 0) {
    return "".concat(prefixCls, "-placement-").concat(placements[0]);
  }

  return '';
}